import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import Input from 'components/Input/Input';
import InstructionsCheckbox from 'components/Input/InstructionsCheckboxInput';
import TokenInput from 'components/Input/TokenInput';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import { apiTokenInstructions, getProviderFormLabel } from '../utils';

const SignInWarpApi = ({
  provider,
  client,
  isLoading,
  onSubmit,
  instructionsLink,
}: RegisterImplementationProps) => {
  const instructions = apiTokenInstructions(provider.displayName, client);

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      instructionsLink={instructionsLink}
      divider
      onSubmit={onSubmit}
      fieldNames={['instructionCheck', 'apiToken', 'companyName']}
      render={({ instructionCheck, apiToken, companyName }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <InstructionsCheckbox
                checked={instructionCheck.value}
                onChange={(checked) => instructionCheck.onChange(checked)}
              />
              {/*
                Warp calls this credential an API key and sends it in the
                `x-api-key` header, so override TokenInput's "API Token"
                default. The request field behind it stays `apiToken` — that is
                the shared Connect field every API-token provider posts to.
              */}
              <TokenInput
                label="API Key"
                value={apiToken.value}
                onChange={(event) => apiToken.onChange(event.target.value)}
                invalid={apiToken.invalid}
              />
              {/*
                Warp's API exposes no company name, EIN, or org id, so the
                customer supplies the legal name here. Without it api-server
                rejects the authorize call and the company sink would have no
                legal name to emit.
              */}
              <Input
                id="companyName"
                label="Company legal name"
                value={companyName.value}
                onChange={(event) => companyName.onChange(event.target.value)}
                invalid={companyName.invalid}
              />
            </MainContainer>
            <LoaderButton
              text="Connect"
              isLoading={isLoading}
              disabled={
                isLoading ||
                !instructionCheck.value ||
                !apiToken.value ||
                !companyName.value
              }
              type="submit"
            />
          </>
        );
      }}
    />
  );
};

export default SignInWarpApi;
